"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateViewPreference = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var noop_1 = (0, tslib_1.__importDefault)(require("lodash/fp/noop"));
var ViewPreferenceApiService_1 = require("../services/ViewPreferenceApiService");
var utils_1 = require("../utils");
var useUpdateViewPreference = function (viewId, app, viewLevel) {
    if (viewLevel === void 0) { viewLevel = 'users'; }
    var lsKey = "ViewPrefs_".concat(viewId, "_").concat(viewLevel, "_").concat(app);
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var updateViewPrefs = function (pageParams, dataParams, onCompleted, onError) {
        if (onCompleted === void 0) { onCompleted = noop_1.default; }
        if (onError === void 0) { onError = noop_1.default; }
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var prevData, res;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevData = (0, utils_1.jsonParser)(localStorage.getItem(lsKey));
                        if (prevData) {
                            localStorage.setItem(lsKey, JSON.stringify((0, tslib_1.__assign)((0, tslib_1.__assign)({}, prevData), { DataParams: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, prevData.DataParams), dataParams), PageParams: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, prevData.PageParams), pageParams) })));
                        }
                        setLoading(true);
                        return [4 /*yield*/, ViewPreferenceApiService_1.ViewPreferenceApiService.post('/views/{clientId}/{userId}', {
                                body: {
                                    app: app || undefined,
                                    viewId: viewId,
                                    viewLevel: viewLevel,
                                    data: {
                                        PageParams: pageParams || undefined,
                                        DataParams: dataParams || undefined,
                                    },
                                },
                            }).then(onCompleted, onError)];
                    case 1:
                        res = _a.sent();
                        setLoading(false);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return [updateViewPrefs, loading];
};
exports.useUpdateViewPreference = useUpdateViewPreference;
